module.exports = __webpack_public_path__ + "media/Images/icon-money-hand-o-5230fef0d6c3fc15b2d9f8fa057999e5.svg";